<div class="toolbar">
  <app-container-standard title="Revenue Report">
    <div class="form-row">
      <div class="form-group col-md-6">
        <mat-form-field class="example-full-width">
          <mat-select placeholder="Select time period" [(value)]="timeSelected" (selectionChange)="setTimePeriode($event.value)">
            <mat-option value="LAST-7-DAYS">Last 7 days</mat-option>
            <mat-option value="TODAY">Today</mat-option>
            <mat-option value="THIS_MONTH">This month</mat-option>
            <mat-option value="LAST_MONTH">Last month</mat-option>
            <mat-option value="CUSTOM">Custom</mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container *ngIf="timeSelected == 'CUSTOM'">
          <mat-form-field>
            <mat-label>Custom Date Range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="Start date" (dateChange)="setCustomRange($event, 'start')">
              <input matEndDate placeholder="End date" (dateChange)="setCustomRange($event, 'end')">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </ng-container>

        <div class="button-row create-button">
          <button (click)="onSubmit()" class="theme-primary white-text float-right" mat-flat-button>Get report</button>
        </div>
      </div>
    </div>

    <div *ngIf="loading" style="margin-top: 16px;"><app-spinner-loading></app-spinner-loading></div>

    <div *ngIf="report && !loading" style="margin-top: 16px;">
      <mat-card>
        <mat-card-title>Revenue summary</mat-card-title>
        <mat-card-content>
          <p>Total price: {{ report.totalPrice | number:'1.2-2' }}</p>
          <p>Total cost: {{ report.totalCost | number:'1.2-2' }}</p>
          <p>Revenue: {{ report.revenue | number:'1.2-2' }}</p>
          <p>Count: {{ report.count }}</p>
        </mat-card-content>
      </mat-card>
    </div>

  </app-container-standard>
</div>
